const Url = {
  baseUrl: window._env_.REACT_APP_BE_URL,
  redirectUrl: window._env_.REACT_APP_BASE_URL,
};
export default Url;